import type { _meta as __page_52_meta } from '$routes/(frontend)/(service-page)/(with-nav)/(en)/digital-visibility/+page.server';
import type { _meta as __page_54_meta } from '$routes/(frontend)/(service-page)/(with-nav)/visibilite-digitale/+page.server';
import type { _meta as __page_34_meta } from '$routes/(frontend)/[[_country]]/annuaire/+page.server';
import type { _meta as __page_33_meta } from '$routes/(frontend)/[[_country]]/devis/+page.server';
import type { _meta as __page_44_meta } from '$routes/(frontend)/[[_country]]/directory/+page.server';
import type { _meta as __page_41_meta } from '$routes/(frontend)/[[_country]]/emploi/metier-[id]-[slug]/+page.server';
import type { _meta as __page_46_meta } from '$routes/(frontend)/[participantId=participantIdWithPrefix]-[[participantSlug]]/feed/[id]/+page.server';
import type { _meta as __page_56_meta } from '$routes/(frontend)/contact-us/+page.server';
import type { _meta as __page_47_meta } from '$routes/(frontend)/contact/+page.server';
import type { _meta as __page_51_meta } from '$routes/(frontend)/en/+page.server';
import type { _meta as __page_57_meta } from '$routes/(frontend)/inbox/+page.server';
import type { _meta as __page_61_meta } from '$routes/(frontend)/inbox/create-thread/+page.server';
import type { _meta as __page_58_meta } from '$routes/(frontend)/inbox/error/+page.server';
import type { _meta as __page_59_meta } from '$routes/(frontend)/inbox/switch-context/+page.server';
import type { _meta as __page_60_meta } from '$routes/(frontend)/inbox/thread/[threadId]/+page.server';
import type { _meta as __page_66_meta } from '$routes/(frontend)/inscription/step/center-of-interest/categories/+page.server';
import type { _meta as __page_64_meta } from '$routes/(frontend)/inscription/step/center-of-interest/companies/+page.server';
import type { _meta as __page_65_meta } from '$routes/(frontend)/inscription/step/center-of-interest/users/+page.server';
import type { _meta as __page_69_meta } from '$routes/(frontend)/inscription/step/confirmation/[userId=integer]/+page.server';
import type { _meta as __page_67_meta } from '$routes/(frontend)/inscription/step/infos-perso/+page.server';
import type { _meta as __page_68_meta } from '$routes/(frontend)/inscription/step/infos-pro/+page.server';
import type { _meta as __page_71_meta } from '$routes/(frontend)/login/+page.server';
import type { _meta as __page_73_meta } from '$routes/(frontend)/newsfeed/+page.server';
import type { _meta as __page_74_meta } from '$routes/(frontend)/newsfeed/hashtag/+page.server';
import type { _meta as __page_27_meta } from '$routes/(frontend)/notifications/+page.server';
import type { _meta as __page_11_meta } from '$routes/(symfony)/[[_country]]/annuaire-resultat/+page.server';
import type { _meta as __page_24_meta } from '$routes/(symfony)/company-ad/click/[adId]/[slot]/+page.server';
import type { _meta as __page_22_meta } from '$routes/(symfony)/company-static-ad/click/[adId]/+page.server';
import * as z from 'zod';
import {
    recordToSearchParams,
    resolveRoutePathWithVariables,
} from '$lib/svelte/routeUtils';

export type Params =
    | {
          id: '/(symfony)/profile/edit';
          params: Record<string, never>;
          searchParams?: undefined;
      }
    | {
          id: '/(symfony)/profile/edit/coordinates';
          params: Record<string, never>;
          searchParams?: undefined;
      }
    | {
          id: '/(symfony)/profile/edit/interests';
          params: Record<string, never>;
          searchParams?: undefined;
      }
    | {
          id: '/(symfony)/profile/edit/password';
          params: Record<string, never>;
          searchParams?: undefined;
      }
    | {
          id: '/(symfony)/profile/edit/resumes';
          params: Record<string, never>;
          searchParams?: undefined;
      }
    | {
          id: '/(symfony)/profile/edit/experiences';
          params: Record<string, never>;
          searchParams?: undefined;
      }
    | {
          id: '/(symfony)/profile/edit/pro';
          params: Record<string, never>;
          searchParams?: undefined;
      }
    | {
          id: '/(symfony)/profile/edit/change-email';
          params: Record<string, never>;
          searchParams?: undefined;
      }
    | {
          id: '/(symfony)/profile/edit/formations';
          params: Record<string, never>;
          searchParams?: undefined;
      }
    | {
          id: '/(symfony)/profile/edit/photos';
          params: Record<string, never>;
          searchParams?: undefined;
      }
    | {
          id: '/(symfony)/profile/edit/languages';
          params: Record<string, never>;
          searchParams?: undefined;
      }
    | {
          id: '/(symfony)/[[_country]]/annuaire-resultat';
          params: { _country?: string | null | undefined };
          searchParams: z.input<(typeof __page_11_meta)['searchParams']>;
      }
    | {
          id: '/(symfony)/[[_country]]/articles/[id]-[slug]';
          params: { _country?: string | null | undefined; id: string; slug: string };
          searchParams?: undefined;
      }
    | {
          id: '/(symfony)/[[_country]]/articles/cat/[id]-[slug]';
          params: { _country?: string | null | undefined; id: string; slug: string };
          searchParams?: undefined;
      }
    | {
          id: '/(symfony)/[[_country]]/nouvelles-societes-[slug]';
          params: { _country?: string | null | undefined; slug: string };
          searchParams?: undefined;
      }
    | {
          id: '/(symfony)/[[_country]]/nouveaux-commentaires-[slug]';
          params: { _country?: string | null | undefined; slug: string };
          searchParams?: undefined;
      }
    | {
          id: '/(symfony)/page/[slug]';
          params: { slug: string };
          searchParams?: undefined;
      }
    | {
          id: '/(symfony)/[_country]/[id]-[slug]';
          params: { _country: string; id: string; slug: string };
          searchParams?: undefined;
      }
    | {
          id: '/(symfony)/entreprises-importantes-afrique';
          params: Record<string, never>;
          searchParams?: undefined;
      }
    | {
          id: '/(symfony)/registration/reset-password';
          params: Record<string, never>;
          searchParams?: undefined;
      }
    | {
          id: '/(symfony)/ajax/file/resume-image/[resumeId]';
          params: { resumeId: string };
          searchParams?: undefined;
      }
    | {
          id: '/(symfony)/company-static-ad/iframe/[adId]';
          params: { adId: string };
          searchParams?: undefined;
      }
    | {
          id: '/(symfony)/company-static-ad/click/[adId]';
          params: { adId: string };
          searchParams: z.input<(typeof __page_22_meta)['searchParams']>;
      }
    | {
          id: '/(symfony)/company-ad/iframe/[adId]/[slot]';
          params: { adId: string; slot: string };
          searchParams?: undefined;
      }
    | {
          id: '/(symfony)/company-ad/click/[adId]/[slot]';
          params: { adId: string; slot: string };
          searchParams: z.input<(typeof __page_24_meta)['searchParams']>;
      }
    | {
          id: '/(frontend)/profile/edit/notification-settings';
          params: Record<string, never>;
          searchParams?: undefined;
      }
    | {
          id: '/(frontend)/profile/edit/portfolio';
          params: Record<string, never>;
          searchParams?: undefined;
      }
    | {
          id: '/(frontend)/notifications';
          params: Record<string, never>;
          searchParams: z.input<(typeof __page_27_meta)['searchParams']>;
      }
    | {
          id: '/(frontend)/company/create';
          params: Record<string, never>;
          searchParams?: undefined;
      }
    | {
          id: '/(frontend)/company/[id]-[slug]/edit/job_offers';
          params: { id: string; slug: string };
          searchParams?: undefined;
      }
    | {
          id: '/(frontend)/company/edit/select';
          params: Record<string, never>;
          searchParams?: undefined;
      }
    | {
          id: '/(frontend)/(profiler)/_next-profiler';
          params: Record<string, never>;
          searchParams?: undefined;
      }
    | {
          id: '/(frontend)/[[_country]]';
          params: { _country?: string | null | undefined };
          searchParams?: undefined;
      }
    | {
          id: '/(frontend)/[[_country]]/devis';
          params: { _country?: string | null | undefined };
          searchParams: z.input<(typeof __page_33_meta)['searchParams']>;
      }
    | {
          id: '/(frontend)/[[_country]]/annuaire';
          params: { _country?: string | null | undefined };
          searchParams?: undefined;
      }
    | {
          id: '/(frontend)/[[_country]]/annuaire/[slug]';
          params: { _country?: string | null | undefined; slug: string };
          searchParams?: undefined;
      }
    | {
          id: '/(frontend)/[[_country]]/pros';
          params: { _country?: string | null | undefined };
          searchParams?: undefined;
      }
    | {
          id: '/(frontend)/[[_country]]/[id]-[slug]';
          params: { _country?: string | null | undefined; id: string; slug: string };
          searchParams?: undefined;
      }
    | {
          id: '/(frontend)/[[_country]]/explorer';
          params: { _country?: string | null | undefined };
          searchParams?: undefined;
      }
    | {
          id: '/(frontend)/[[_country]]/emploi';
          params: { _country?: string | null | undefined };
          searchParams?: undefined;
      }
    | {
          id: '/(frontend)/[[_country]]/emploi/publier';
          params: { _country?: string | null | undefined };
          searchParams?: undefined;
      }
    | {
          id: '/(frontend)/[[_country]]/emploi/metier-[id]-[slug]';
          params: { _country?: string | null | undefined; id: string; slug: string };
          searchParams: z.input<(typeof __page_41_meta)['searchParams']>;
      }
    | {
          id: '/(frontend)/[[_country]]/emploi/job-[id]-[slug]';
          params: { _country?: string | null | undefined; id: string; slug: string };
          searchParams?: undefined;
      }
    | {
          id: '/(frontend)/[[_country]]/emploi/metiers';
          params: { _country?: string | null | undefined };
          searchParams?: undefined;
      }
    | {
          id: '/(frontend)/[[_country]]/directory';
          params: { _country?: string | null | undefined };
          searchParams?: undefined;
      }
    | {
          id: '/(frontend)/[[_country]]/user/[userId=integer]-[[userSlug]]';
          params: {
              _country?: string | null | undefined;
              userId: string;
              userSlug?: string | null | undefined;
          };
          searchParams?: undefined;
      }
    | {
          id: '/(frontend)/[participantId=participantIdWithPrefix]-[[participantSlug]]/feed/[id]';
          params: {
              participantId: string;
              participantSlug?: string | null | undefined;
              id: string;
          };
          searchParams: z.input<(typeof __page_46_meta)['searchParams']>;
      }
    | {
          id: '/(frontend)/contact';
          params: Record<string, never>;
          searchParams?: undefined;
      }
    | {
          id: '/(frontend)/contact/unsuspend/[companyId=integer]';
          params: { companyId: string };
          searchParams?: undefined;
      }
    | {
          id: '/(frontend)/contact/link/[companyId=integer]';
          params: { companyId: string };
          searchParams?: undefined;
      }
    | {
          id: '/(frontend)/notification/link/[id]';
          params: { id: string };
          searchParams?: undefined;
      }
    | {
          id: '/(frontend)/en';
          params: Record<string, never>;
          searchParams?: undefined;
      }
    | {
          id: '/(frontend)/(service-page)/(with-nav)/(en)/digital-visibility';
          params: Record<string, never>;
          searchParams?: undefined;
      }
    | {
          id: '/(frontend)/(service-page)/(with-nav)/en/internet-services';
          params: Record<string, never>;
          searchParams?: undefined;
      }
    | {
          id: '/(frontend)/(service-page)/(with-nav)/visibilite-digitale';
          params: Record<string, never>;
          searchParams?: undefined;
      }
    | {
          id: '/(frontend)/(service-page)/(with-nav)/services-internet';
          params: Record<string, never>;
          searchParams?: undefined;
      }
    | {
          id: '/(frontend)/contact-us';
          params: Record<string, never>;
          searchParams?: undefined;
      }
    | {
          id: '/(frontend)/inbox';
          params: Record<string, never>;
          searchParams: z.input<(typeof __page_57_meta)['searchParams']>;
      }
    | {
          id: '/(frontend)/inbox/error';
          params: Record<string, never>;
          searchParams: z.input<(typeof __page_58_meta)['searchParams']>;
      }
    | {
          id: '/(frontend)/inbox/switch-context';
          params: Record<string, never>;
          searchParams: z.input<(typeof __page_59_meta)['searchParams']>;
      }
    | {
          id: '/(frontend)/inbox/thread/[threadId]';
          params: { threadId: string };
          searchParams: z.input<(typeof __page_60_meta)['searchParams']>;
      }
    | {
          id: '/(frontend)/inbox/create-thread';
          params: Record<string, never>;
          searchParams: z.input<(typeof __page_61_meta)['searchParams']>;
      }
    | {
          id: '/(frontend)/inscription';
          params: Record<string, never>;
          searchParams?: undefined;
      }
    | {
          id: '/(frontend)/inscription/step/company';
          params: Record<string, never>;
          searchParams?: undefined;
      }
    | {
          id: '/(frontend)/inscription/step/center-of-interest/companies';
          params: Record<string, never>;
          searchParams: z.input<(typeof __page_64_meta)['searchParams']>;
      }
    | {
          id: '/(frontend)/inscription/step/center-of-interest/users';
          params: Record<string, never>;
          searchParams: z.input<(typeof __page_65_meta)['searchParams']>;
      }
    | {
          id: '/(frontend)/inscription/step/center-of-interest/categories';
          params: Record<string, never>;
          searchParams: z.input<(typeof __page_66_meta)['searchParams']>;
      }
    | {
          id: '/(frontend)/inscription/step/infos-perso';
          params: Record<string, never>;
          searchParams: z.input<(typeof __page_67_meta)['searchParams']>;
      }
    | {
          id: '/(frontend)/inscription/step/infos-pro';
          params: Record<string, never>;
          searchParams: z.input<(typeof __page_68_meta)['searchParams']>;
      }
    | {
          id: '/(frontend)/inscription/step/confirmation/[userId=integer]';
          params: { userId: string };
          searchParams: z.input<(typeof __page_69_meta)['searchParams']>;
      }
    | {
          id: '/(frontend)/inscription/bienvenue';
          params: Record<string, never>;
          searchParams?: undefined;
      }
    | {
          id: '/(frontend)/login';
          params: Record<string, never>;
          searchParams: z.input<(typeof __page_71_meta)['searchParams']>;
      }
    | {
          id: '/(frontend)/logout';
          params: Record<string, never>;
          searchParams?: undefined;
      }
    | {
          id: '/(frontend)/newsfeed';
          params: Record<string, never>;
          searchParams: z.input<(typeof __page_73_meta)['searchParams']>;
      }
    | {
          id: '/(frontend)/newsfeed/hashtag';
          params: Record<string, never>;
          searchParams: z.input<(typeof __page_74_meta)['searchParams']>;
      }
    | {
          id: '/(frontend)/newsfeed/bookmark/[bookmarkId=integer]';
          params: { bookmarkId: string };
          searchParams?: undefined;
      }
    | {
          id: '/(frontend)/newsfeed/bookmark/all';
          params: Record<string, never>;
          searchParams?: undefined;
      }
    | {
          id: '/(frontend)/newsfeed/user-posts/[id=integer]';
          params: { id: string };
          searchParams?: undefined;
      }
    | {
          id: '/(frontend)/newsfeed/category-posts/[categoryId=integer]';
          params: { categoryId: string };
          searchParams?: undefined;
      }
    | {
          id: '/(frontend)/newsfeed/my-pending-posts';
          params: Record<string, never>;
          searchParams?: undefined;
      }
    | {
          id: '/(frontend)/(profiler)/_next-profiler/request-[id]';
          params: { id: string };
          searchParams?: undefined;
      }
    | {
          id: '/(frontend)/(profiler)/_next-profiler/request-[id]/elastic';
          params: { id: string };
          searchParams?: undefined;
      }
    | {
          id: '/(frontend)/(profiler)/_next-profiler/request-[id]/sql';
          params: { id: string };
          searchParams?: undefined;
      }
    | {
          id: '/(frontend)/(profiler)/_next-profiler/request-[id]/log';
          params: { id: string };
          searchParams?: undefined;
      }
    | {
          id: '/(frontend)/(service-page)/(with-nav)/avis-clients';
          params: Record<string, never>;
          searchParams?: undefined;
      }
    | {
          id: '/(frontend)/(service-page)/(with-nav)/rendez-vous-en-ligne';
          params: Record<string, never>;
          searchParams?: undefined;
      }
    | {
          id: '/(frontend)/(service-page)/(with-nav)/devis-centralises';
          params: Record<string, never>;
          searchParams?: undefined;
      }
    | {
          id: '/(frontend)/(service-page)/(with-nav)/campagnes-emails-sms';
          params: Record<string, never>;
          searchParams?: undefined;
      }
    | {
          id: '/(frontend)/(service-page)/(with-nav)/(land)/land-entreprises-visibilite-digitale';
          params: Record<string, never>;
          searchParams?: undefined;
      }
    | {
          id: '/(frontend)/(service-page)/(with-nav)/(land)/land-membres-emploi';
          params: Record<string, never>;
          searchParams?: undefined;
      }
    | {
          id: '/(frontend)/(service-page)/(with-nav)/afrikad-monetisation-site-internet';
          params: Record<string, never>;
          searchParams?: undefined;
      }
    | {
          id: '/(frontend)/(service-page)/(with-nav)/reseau-social-professionnel';
          params: Record<string, never>;
          searchParams?: undefined;
      }
    | {
          id: '/(frontend)/(service-page)/(with-nav)/charte-verification-entreprise';
          params: Record<string, never>;
          searchParams?: undefined;
      }
    | {
          id: '/(frontend)/(service-page)/(with-nav)/messagerie-instantannee';
          params: Record<string, never>;
          searchParams?: undefined;
      }
    | {
          id: '/(frontend)/(service-page)/(with-nav)/produits-en-ligne';
          params: Record<string, never>;
          searchParams?: undefined;
      }
    | {
          id: '/(frontend)/(service-page)/[[_country]]/landpro-enseignement-superieur-universite';
          params: { _country?: string | null | undefined };
          searchParams?: undefined;
      }
    | {
          id: '/(frontend)/(service-page)/[[_country]]/landpro-bureaux-etude-conseil';
          params: { _country?: string | null | undefined };
          searchParams?: undefined;
      }
    | {
          id: '/(frontend)/(service-page)/[[_country]]/landpro-expert-comptable';
          params: { _country?: string | null | undefined };
          searchParams?: undefined;
      }
    | {
          id: '/(frontend)/(service-page)/[[_country]]/landpro-gardiennage-securite';
          params: { _country?: string | null | undefined };
          searchParams?: undefined;
      }
    | {
          id: '/(frontend)/(service-page)/[[_country]]/landpro-nettoyage-industriel';
          params: { _country?: string | null | undefined };
          searchParams?: undefined;
      }
    | {
          id: '/(frontend)/(service-page)/[[_country]]/landpro-architecte';
          params: { _country?: string | null | undefined };
          searchParams?: undefined;
      }
    | {
          id: '/(frontend)/(service-page)/[[_country]]/landpro-construction';
          params: { _country?: string | null | undefined };
          searchParams?: undefined;
      }
    | {
          id: '/(frontend)/(service-page)/[[_country]]/landpro-formation-professionnelle';
          params: { _country?: string | null | undefined };
          searchParams?: undefined;
      }
    | {
          id: '/(frontend)/(service-page)/[[_country]]/landpro-mobilier-de-bureau';
          params: { _country?: string | null | undefined };
          searchParams?: undefined;
      }
    | {
          id: '/(frontend)/(service-page)/[[_country]]/landpro-preinscription-visa-etude';
          params: { _country?: string | null | undefined };
          searchParams?: undefined;
      }
    | {
          id: '/(frontend)/(service-page)/[[_country]]/landpro-equipements-medicaux';
          params: { _country?: string | null | undefined };
          searchParams?: undefined;
      }
    | {
          id: '/(frontend)/(service-page)/[[_country]]/landpro-garages-mecanique-generale';
          params: { _country?: string | null | undefined };
          searchParams?: undefined;
      };
export type RouteByNameParams =
    | {
          name: 'directory';
          params: { _country?: string | null | undefined };
          lang: string;
          searchParams?: undefined;
      }
    | {
          name: 'contact';
          params: Record<string, never>;
          lang: string;
          searchParams?: undefined;
      }
    | {
          name: 'service-page.visibilite_digitale';
          params: Record<string, never>;
          lang: string;
          searchParams?: undefined;
      };

export function resolveRoute(route: Params) {
    let params = route.params as Record<string, string | undefined>;
    // Ensure _country is lowercase if it exists
    if (params && '_country' in params && typeof params._country === 'string') {
        params = {
            ...params,
            _country: params._country.toLowerCase(),
        };
    }

    const path = resolveRoutePathWithVariables(route.id, params);
    return `${path}${recordToSearchParams(route.searchParams ?? null)
        .sort()
        .toString()}`;
}
export function resolveRouteByName(route: RouteByNameParams): string {
    if (route.name === 'directory') {
        if (route.lang === 'fr') {
            return resolveRoute({
                id: '/(frontend)/[[_country]]/annuaire',
                params: route.params,
                searchParams: route.searchParams,
            });
        }
        if (route.lang === 'en') {
            return resolveRoute({
                id: '/(frontend)/[[_country]]/directory',
                params: route.params,
                searchParams: route.searchParams,
            });
        }
        return resolveRoute({
            id: '/(frontend)/[[_country]]/annuaire',
            params: route.params,
            searchParams: route.searchParams,
        });
    }
    if (route.name === 'contact') {
        if (route.lang === 'fr') {
            return resolveRoute({
                id: '/(frontend)/contact',
                params: route.params,
                searchParams: route.searchParams,
            });
        }
        if (route.lang === 'en') {
            return resolveRoute({
                id: '/(frontend)/contact-us',
                params: route.params,
                searchParams: route.searchParams,
            });
        }
        return resolveRoute({
            id: '/(frontend)/contact',
            params: route.params,
            searchParams: route.searchParams,
        });
    }
    if (route.name === 'service-page.visibilite_digitale') {
        if (route.lang === 'en') {
            return resolveRoute({
                id: '/(frontend)/(service-page)/(with-nav)/(en)/digital-visibility',
                params: route.params,
                searchParams: route.searchParams,
            });
        }
        if (route.lang === 'fr') {
            return resolveRoute({
                id: '/(frontend)/(service-page)/(with-nav)/visibilite-digitale',
                params: route.params,
                searchParams: route.searchParams,
            });
        }
        return resolveRoute({
            id: '/(frontend)/(service-page)/(with-nav)/visibilite-digitale',
            params: route.params,
            searchParams: route.searchParams,
        });
    }
    return '';
}
